import React, { useEffect, useState } from "react";
import moment from "moment";
import flightIcon from "../../assets/images/EtihadFlightLogo.png";
import BookwithmilesIcon from "../../assets/images/Bookwithmiles.png";
import TruckIcon from "../../assets/images/truck.svg";
import timeIcon from "../../assets/images/Flight-status.png";
import warning_filled from "../../assets/images/warning_filled.svg";
import closeIcon from "../../assets/images/close.png";
import line from "../../assets/images/Line 518.svg";
import { useTranslation } from "react-i18next";
import {
  getDecimalFormattedNumber,
  getRoundedValue,
  getWeightUnit,
  WEIGHT_UNIT,
} from "../../constants";
import "./flightDetailsPopup.scss"; 

const FlightDetailsPopup = ({
  destinationAirport,
  searchFormData,
  onClose,
  showDropoffPickup,
  showFooter,
}) => {
  const { t } = useTranslation(["labels", "errors"]);

  const getFormatedTime = (value) => {
    let formattedTime = "";
    if (value) {
      let tempArray = value.split(":");
      formattedTime =
        parseInt(tempArray[0], 10) +
        "Hrs " +
        (tempArray[1] && tempArray[1] !== "00" ? tempArray[1] + " Min" : "");
    }
    return formattedTime;
  };

  const capitalizeWords = (str) => {
    if (!str) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

 const formatCityName = (city) => {
    if (!city) return '';
    return city
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

const formatAddress = (address) => {
  if (!address) return "--";

  const { name, streetAndHouseNumber, country, city, postCode } = address;

  const addressData = [
    name,
    streetAndHouseNumber,
    country,
    city && postCode ? `${city} ${postCode}` : city || postCode
  ].filter(Boolean); 

  if (addressData?.length === 0) return "--";

  return addressData.map((data, index) => (
    <React.Fragment key={index}>
      {data}
      {index < addressData.length - 1 && <>, </>}
      {(data === name || data === country) && <br />}
    </React.Fragment>
  ));
};



  const destination = destinationAirport?.destination;
  const dropoffAirportAddress = destinationAirport?.destination;
  const originCity = destinationAirport?.originCityName;
  const destinationCity = destinationAirport?.destCityName;
  const pickUpAirportCity = destinationAirport?.pickUpAddress?.city;
  let routes = destinationAirport?.flightSegmentList
    ? destinationAirport.flightSegmentList.length - 1
    : 0;

   const safeTime = (val) => {
    if (!val) return "--";
    const m = moment(val);
    return m.isValid() ? m.format("HH:mm") : "--";
  };

  return (
    <div className="flight-details__popup">
      <div className="flight-details__popup__header">
        <div className="popup-heading">
          {formatCityName(originCity)} to{" "}
          {formatCityName(destinationCity)}{" "}
        </div>
        <button className="flight-details__popup__close">
          <img src={closeIcon} alt="close" onClick={onClose}></img>
        </button>
      </div>
      <div className="divider"></div>
      <div className="flight-details__popup-body">
        {destinationAirport?.flightSegmentList.map((segment, index) => (
          <React.Fragment key={index}>
            <div className="flight-leg">
              <div className="flight-details-timeline">
                <div className="flight-details-timeline-top">
                  <div className="time-section">
                    <div className="time-heading">
                      {/* {moment(segment?.departureDateTime).format("HH:mm")} */}
                      {safeTime(segment?.departureDateTime)}
                    </div>
                    <img src={line} alt="line" className="time-line"></img>
                  </div>
                  <div>
                    <div className="departure-airport">
                      {formatCityName(segment?.originCityName)}
                    </div>
                    <div className="departure-airport-address">
                      {segment?.originAirportName} ({segment?.segmentOrigin})
                    </div>
                  </div>
                </div>
                <div className="flight-details-timeline-bottom">
                  <div className="time-heading">
                    {/* {moment(segment?.arrivalDateTime).format("HH:mm")} */}
                    {safeTime(segment?.arrivalDateTime)}
                  </div>
                  <div>
                    <div className="departure-airport">
                      {formatCityName(segment?.destCityName)}
                    </div>
                    <div className="departure-airport-address">
                      {segment?.destAirportName} ({segment?.segmentDestination})
                    </div>
                  </div>
                </div>
              </div>

              <div className="flight-details-duration">
                <div className="details-parameters">
                  <img
                    src={flightIcon}
                    alt="Flight Number"
                    className="flight-icon"
                  />
                  <div className="carrier-code">
                    {segment?.flightCarrierCode}
                    {segment?.flightNumber}
                  </div>
                </div>
                <div className="details-parameters">
                  {/* <img
                    src={BookwithmilesIcon}
                    alt="Aircraft Type"
                    className="flight-icon"
                  /> */}
                  {segment?.aircraftClassification === "Truck" ? (
                    <img
                      src={TruckIcon}   
                      alt="Truck"
                      className="flight-icon"
                    />
                  ) : (
                    <img
                      src={BookwithmilesIcon}
                      alt="Aircraft Type"
                      className="flight-icon"
                    />
                  )}
                  <div className="carrier-code">
                    {segment?.aircraftType}
                    {segment?.aircraftClassification && (
                      <> | {segment?.aircraftClassification}</>
                    )}
                  </div>
                </div>
                <div className="details-parameters">
                  <img
                    src={timeIcon}
                    alt="Classification"
                    className="flight-icon"
                  />
                  <div className="carrier-code">
                    Duration {getFormatedTime(segment?.flyingHours)}
                  </div>
                </div>
              </div>
            </div>

            {index < destinationAirport?.flightSegmentList.length - 1 && (
              <div className="stop-information">
                <div className="divider-stop"></div>
                <div className="stop-value">
                  {/* {routes} {t("COMMON.STOP")} */}
                   {t("COMMON.STOP")}
                  {segment?.segmentDestination !== destination && (
                    <>
                      {" "}
                      at {segment?.segmentDestination} for{" "}
                      {getFormatedTime(segment?.layoverTime)}
                    </>
                  )}
                </div>
                <div className="divider"></div>
              </div>
            )}
          </React.Fragment>
        ))}

        {showFooter && (
          <div className="bottom-block">
            <div className="divider"></div>
            {showDropoffPickup ? (
              <div className="bottom-block-section">
                <div className="bottom-block-section-cell">
                  <div className="lat">LAT ({t("CHOOSE_FLT.LAT_FILTER")}) </div>
                  <div className="lat-value">
                    {moment(destinationAirport?.lastAcceptanceTime).format(
                      "HH:mm"
                    )}{" "}
                    {moment(
                      destinationAirport?.lastAcceptanceTime,
                      "DD-MMM-YYYY"
                    ).format("ddd DD MMM")}
                  </div>
                </div>

                <div className="bottom-block-section-cell">
                  <div className="lat">
                    {" "}
                    TOA ({t("CHOOSE_FLT.TOA_FILTER")}){" "}
                  </div>
                  <div className="lat-value">
                    {moment(destinationAirport?.earliestDeliveryTime).format(
                      "HH:mm"
                    )}{" "}
                    {moment(
                      destinationAirport?.earliestDeliveryTime,
                      "DD-MMM-YYYY"
                    ).format("ddd DD MMM")}
                  </div>
                </div>

                <div className="bottom-block-section-cell">
                  <div className="lat">{t("COMMON.CH_WT")}</div>
                  <div className="lat-value">
                    {getRoundedValue(searchFormData?.chargeableWeight)}
                    {getWeightUnit(WEIGHT_UNIT.KILOGRAM)}
                  </div>
                </div>
              </div>
            ) : (
              <div className="address-container">
                <div className="address">
                  <div className="address-cell">
                    <div className="drop-off-address-text">{t("COMMON.DROP_OFF")}</div>

                    <div className="drop-off-address">
                       {formatAddress(destinationAirport?.dropOffAddress)}
                      {/* {destinationAirport.dropOffAddress.name},<br />
                      {
                        destinationAirport.dropOffAddress.streetAndHouseNumber
                      }, {destinationAirport.dropOffAddress.country},<br />
                      {destinationAirport.dropOffAddress.city},{" "}
                      {destinationAirport.dropOffAddress.postCode} */}
                    </div>
                  </div>
                  
                    <div className="address-cell">
                      <div className="drop-off-address-text">{t("COMMON.PICK_UP")}</div>

                      <div className="drop-off-address">
                       {/* {destinationAirport.pickUpAddress.name},<br />
                      {
                        destinationAirport.pickUpAddress.streetAndHouseNumber
                      }, {destinationAirport.pickUpAddress.country},<br />
                      {destinationAirport.pickUpAddress.city},{" "}
                      {destinationAirport.pickUpAddress.postCode} */}
                         {formatAddress(destinationAirport?.pickUpAddress)}
                      </div>
                   
                  </div>
                </div>

                <div className="address">
                  <div className="address-cell">
                    <div className="drop-off-address-text">LAT ({t("CHOOSE_FLT.LAT_FILTER")}) </div>

                    <div className="drop-off-address">
                        {destinationAirport?.lastAcceptanceTime
                          ? (
                            <>
                              {moment(destinationAirport?.lastAcceptanceTime).format("HH:mm")}{" "}
                              {moment(destinationAirport?.lastAcceptanceTime, "DD-MMM-YYYY").format("ddd DD MMM")}
                            </>
                          )
                          : "--"
                        }
                    </div>
                  </div>
                  
                    <div className="address-cell">
                      <div className="drop-off-address-text">TOA ({t("CHOOSE_FLT.TOA_FILTER")}) </div>

                      <div className="drop-off-address">
                         {destinationAirport?.earliestDeliveryTime
                          ? (
                            <>
                              {moment(destinationAirport?.earliestDeliveryTime).format("HH:mm")}{" "}
                              {moment(destinationAirport?.earliestDeliveryTime, "DD-MMM-YYYY").format("ddd DD MMM")}
                            </>
                          )
                          : "--"
                        }
                      </div>
                    </div>
                  
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* <div className="flight-details__popup__content">
        <div className="flight-details__popup__segment-info">
          {destinationAirport.flightSegmentList.map((segment, index) => (
            <React.Fragment key={index}>
              <div className="flight-details__popup__segment">
                
                <div className="flight-details__popup__route">
                  <div className="flight-details__popup__departure">
                    <strong>
                      {moment(segment.departureDateTime).format("HH:mm")}
                    </strong>
                    <div className="flight-details__popup__departure-details-right">
                      <strong>{segment.segmentOrigin}</strong>
                      <span>
                        {dropoffAirportAddress} ({segment.segmentOrigin})
                      </span>
                    </div>
                  </div>
                  <div className="flight-details__popup__connection">
                    <div className="origin-destination__popup_icon dark"></div>
                    <div className="popup__transit-line"></div>
                    <div className="origin-destination__popup_icon dark"></div>
                  </div>
                  <div className="flight-details__popup__arrival">
                    <strong>
                      {moment(segment.arrivalDateTime).format("HH:mm")}
                    </strong>
                    <div className="flight-details__popup__departure-details-right">
                      <strong>{segment.segmentDestination}</strong>
                      <span>
                        {pickupAirportAddress} ({segment.segmentDestination})
                      </span>
                    </div>
                  </div>
                </div>

                
                <div className="flight-details__popup__flightNo">
                  <div className="flight-details__popup__flightNo-item">
                    <img src={flightIcon} alt="Flight Number" />
                    <span>
                      {segment.flightCarrierCode}
                      {segment.flightNumber}
                    </span>
                  </div>
                  <div className="flight-details__popup__flightNo-item">
                    <img src={BookwithmilesIcon} alt="Aircraft Type" />
                    <span>
                      {segment.aircraftType}
                      {segment.aircraftClassification && (
                        <> | {segment.aircraftClassification}</>
                      )}
                    </span>
                  </div>
                  <div className="flight-details__popup__flightNo-item">
                    <img src={timeIcon} alt="Classification" />
                    <span>
                      {" "}
                      Duration {getFormatedTime(segment.flyingHours)}
                    </span>
                  </div>
                 
                </div>
              </div>

             
              {index < destinationAirport.flightSegmentList.length - 1 && (
                <div className="flight-details__popup__routes">
                  <span>
                    {routes} {t("COMMON.STOP")}
                    {segment.segmentDestination !== destination && (
                      <>
                        {" "}
                        in {segment.segmentDestination} for{" "}
                        {getFormatedTime(segment.layoverTime)}
                      </>
                    )}
                  </span>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        {showFooter && (
          <>
            <div className="flight-details__popup__separator"></div>
            {showDropoffPickup ? (
              <div className="flight-details__popup__others">
                <div className="time-details col-14">
                  <div className="other-value">
                    <div className="chargeable-weight">
                      LAT <span>({t("CHOOSE_FLT.LAT_FILTER")}) </span>
                    </div>
                    <div className="other-value">
                      <span className="time-field">
                        {moment(destinationAirport.lastAcceptanceTime).format(
                          "HH:mm"
                        )}{" "}
                      </span>
                      {moment(
                        destinationAirport.lastAcceptanceTime,
                        "DD-MMM-YYYY"
                      ).format("ddd DD MMM")}
                    </div>
                  </div>
                </div>
                <div className="weight-details col-4">
                  <div className="other-value pb-1">
                    <div className="chargeable-weight">
                      TOA <span>({t("CHOOSE_FLT.TOA_FILTER")}) </span>
                    </div>
                    <div className="other-value pb-1">
                      <span className="time-field">
                        {moment(destinationAirport.earliestDeliveryTime).format(
                          "HH:mm"
                        )}{" "}
                      </span>
                      {moment(
                        destinationAirport.earliestDeliveryTime,
                        "DD-MMM-YYYY"
                      ).format("ddd DD MMM")}
                    </div>
                  </div>
                </div>
                <div className="other-value chargeable-weight_wrap col-4">
                  <div className="chargeable-weight">{t("COMMON.CH_WT")}</div>
                  <div className="other-value">
                    {getRoundedValue(searchFormData?.chargeableWeight)}
                    {getWeightUnit(WEIGHT_UNIT.KILOGRAM)}
                  </div>
                </div>
              </div>
            ) : (
              <div className="address-time-container">
               
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="chargeable-weight">
                      {t("COMMON.DROP_OFF")}
                    </div>
                    <div className="other-value">
                      {destinationAirport.dropOffAddress.name},<br />
                      {
                        destinationAirport.dropOffAddress.streetAndHouseNumber
                      }, {destinationAirport.dropOffAddress.country},<br />
                      {destinationAirport.dropOffAddress.city},{" "}
                      {destinationAirport.dropOffAddress.postCode}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="chargeable-weight">
                      {t("COMMON.PICK_UP")}
                    </div>
                    <div className="other-value">
                      {destinationAirport.pickUpAddress.name},<br />
                      {
                        destinationAirport.pickUpAddress.streetAndHouseNumber
                      }, {destinationAirport.pickUpAddress.country},<br />
                      {destinationAirport.pickUpAddress.city},{" "}
                      {destinationAirport.pickUpAddress.postCode}
                    </div>
                  </div>
                </div>

               
                <div className="row">
                  <div className="col-md-6">
                    <div className="chargeable-weight">
                      LAT <span>({t("CHOOSE_FLT.LAT_FILTER")}) </span>
                    </div>

                    <div className="other-value">
                      <span className="">
                        {moment(destinationAirport.lastAcceptanceTime).format(
                          "HH:mm"
                        )}{" "}
                      </span>
                      {moment(
                        destinationAirport.lastAcceptanceTime,
                        "DD-MMM-YYYY"
                      ).format("ddd DD MMM")}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="chargeable-weight">
                      TOA <span>({t("CHOOSE_FLT.TOA_FILTER")}) </span>
                    </div>

                    <div className="other-value">
                      <span className="">
                        {moment(destinationAirport.earliestDeliveryTime).format(
                          "HH:mm"
                        )}{" "}
                      </span>
                      {moment(
                        destinationAirport.earliestDeliveryTime,
                        "DD-MMM-YYYY"
                      ).format("ddd DD MMM")}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div> */}
    </div>
  );
};

export default FlightDetailsPopup;
